module.exports = __webpack_public_path__ + "static/customer-experience-improvement-f6c726ff99abff03d0f9b823bee4ef93.png";